<template>
	<div>
		<v-card flat color="transparent">
			<v-card-text>
				<v-row align="center">
					<v-col cols="12" md="3" lg="3" class="mx-0 px-0">
                        <alternativeTextField2
                            @onChanged="(v) => {trySearch(v);}"
                            @onClear="(v) => {trySearch(v);}"
                            :valueInput="tableProps.search"
                            :rule="[]"
                            :placeholder="'Buscar'"
                            :label="''"
                            :clearable="true"
                            :prependInnerIcon="'mdi-magnify'"
                            class="pick-3"
                        ></alternativeTextField2>
					</v-col>
					<v-spacer></v-spacer>
					<v-col v-permission="'contractor_payments.create'" cols="12" md="3" lg="4" xl="2" class="">
                        <v-row justify="end">
                            <iconButton class="mr-2" :props="exportBtnData"></iconButton>
                            <iconButton :props="createBtnData"></iconButton>
                        </v-row>
					</v-col>
				</v-row>
				<v-row>
					<v-col class="mx-0 px-0">
						<datatablePagination :options="options" :total="total"  :props="tableProps" @methodHandler="method_handler" @handleOptions="handleOptions">
                           
                        </datatablePagination>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>


        <!-- EXPORT MODAL -->

        <modal :props="modalExportProps" @modalResponse="method_handler">
            <!-- body -->
            
            <template slot="cardBody">
                <p class="mb-0 text-center">Selecciona un proveedor y el formato en que deseas el reporte</p>
                <div class="my-2">
                    <v-row>
                        <v-col class="py-2">
                            <autocompleteOneForm
                                label="Proveedor"
                                :loading="loadingProvider"
                                :valueInput="providerId"
                                :rule="[]"
                                :items="providers"
                                @valueChange="(v) => {providerId = v;}"
                            ></autocompleteOneForm>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <radioInputForm
                                title="Formato del archivo"
                                :radiosData="radios"
                                :valueInput="format"
                                @valueChange="(v) => {format = v;}"
                            ></radioInputForm>
                        </v-col>
                    </v-row>
                </div>

            </template>

			<!-- Buttons -->
			<template slot="cardActions">
				<v-row justify="end">
					<v-col cols="12" sm="4">
						<secondaryButton
						:props="cancelExportModal"
						></secondaryButton>
					</v-col>
					<v-col cols="12" sm="4">
						<primaryButton
						:props="acceptExportModal"
						></primaryButton>
					</v-col>
				</v-row>
			</template> 
		</modal>



        <!-- DELETE MODAL -->
        <modal :props="modalProps" @modalResponse="method_handler">
			<!-- Buttons -->
			<template slot="cardActions">
				<v-row justify="end">
					<v-col cols="12" sm="4">
						<secondaryButton
						:props="cancelModal"
						></secondaryButton>
					</v-col>
					<v-col cols="12" sm="4">
						<primaryButton
						:props="acceptModal"
						></primaryButton>
					</v-col>
				</v-row>
			</template> 
		</modal>
		
	</div>
</template>
<script>
import PageStateManager from '../../../helpers/PageStateManager';
import Utils from '../../../helpers/Utils';
export default {
    watch: {
        ['$route.params.construction'](){
            
            this.construction = this.$route.params.construction;
            this.providerId = "all";
            this.providers = [];
            this.index();
        }
    },
    data(){
		return {
            loadingProvider:false,
            construction: this.$route.params.construction,
            options: JSON.parse(PageStateManager.getState(this.$router.history.current.path, 'optionsIndexTable'))??{},
            total: 10,
			search: '',
            selectedID: '',
            providerId: 'all',
            providers: [],
            format: 'pdf',
            radios:[
                {
                    label: "xlsx",
                    value: "xlsx",
                    mr: 4,
                },
                {
                    label: "pdf",
                    value: "pdf",
                    mr: 3,
                },
            ],
			actions: [
				
				{
					name: 'Editar',
					icon: {
						color: 'secondary',
						icon: 'mdi-pencil-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '/obras/1/edicion',
                    permissions: 'contractor_payments.update'
				},
				{
					name: 'Borrar',
					icon: {
						color: 'secondary',
						icon: 'mdi-delete-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'deleteItemModal',
                    permissions: 'contractor_payments.delete'
				},
			],
			tableProps: {
				headers: [
					{
						text: 'Folio',
						align: 'left',
						value: 'folio',
						
						class: 'table-b-border black--text'
					},
                    {
						text: 'Obra',
						align: 'left',
						value: 'contractor_payable_account_folio',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Proveedor',
						align: 'left',
						value: 'provider_name',
						class: 'table-b-border black--text'
					},
                    // {
					// 	text: 'Forma de pago',
					// 	align: 'left',
					// 	value: 'payment_method_name',
                        
					// 	class: 'table-b-border black--text'
					// },
                    // {
					// 	text: 'Cuenta',
					// 	align: 'left',
                       
					// 	value: 'bank_account_name',
					// 	class: 'table-b-border black--text'
					// },
                    {
						text: 'Cuenta',
						align: 'left',
						value: 'concept_name',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Fecha',
						align: 'left',
						value: 'date',
                        
						class: 'table-b-border black--text'
					},
                    {
						text: 'Monto',
						align: 'left',
                        
						value: 'total',
						class: 'table-b-border black--text'
					},
                   
					{
						text: 'Acciones',
						align: 'right',
						sortable: false,
						value: 'actions',
						width: '10%',
						class: 'table-b-border black--text'
					}
				],
				items: [],
				search: (JSON.parse(PageStateManager.getState(this.$router.history.current.path, 'optionsIndexTable')))?.search??"",
				loading: false,
                sortBy: 'created_at',
                sortDesc: true,
			},
			
			
            createBtnData: {
                hasTooltip:true,
                tooltip: 'Nueva estimación',
                color:'primary',
                iconColor:'grey darken-3',
                height:'35',
                icon: "mdi-plus",
				to: "ContractorsPaymentsCreate",
				block: false,
                click: ()=>{}
            },

            exportBtnData: {
                hasTooltip:true,
                tooltip: 'Exportar',
                color:'primary',
                iconColor:'grey darken-3',
                height:'35',
                icon: "mdi-progress-download",
                iconClass: "flip",
                loading: false,
				to: "",
				block: false,
                click: ()=>{this.openExportModal()}
            },

			modalProps: {
				visible: false,
				width: '500',
				title: 'Eliminar',
				text: '¿Estás seguro de eliminar?',
				loading: false,
				bottomLineColor: 'error',
				
			},
			
			cancelModal: {
                text: "No, cancelar",
                icon: "",
				to: "",
				block: true,
				color: '',
                click: ()=>{this.modalProps.visible = false}
            },
			acceptModal: {
                text: "SI, ELIMINAR",
                icon: "",
				to: "",
				block: true,
				color: 'error',
				textColor:'white',
                textColorLevel: '0',
				loading:false,
                click: ()=>{this.delete()}
            },


            modalExportProps: {
				visible: false,
				width: '600',
				title: 'Descargar reporte de estimaciones',
				text: '',
				loading: false,
				bottomLineColor: 'primary',
				
			},
			
			cancelExportModal: {
                text: "Cancelar",
                icon: "",
				to: "",
				block: true,
				color: '',
                click: ()=>{this.modalExportProps.visible = false}
            },
			acceptExportModal: {
                text: "Descargar",
                icon: "",
				to: "",
				block: true,
				color: 'primary',
				textColor:'black',
                textColorLevel: '2',
				loading:false,
                click: ()=>{this.export()}
            },
		}
	},

	mounted(){
       
	},

    methods: {
        method_handler(object){
            console.log(object);
			this[object.methodName](object.parameters)
		},
        handleOptions(object){
            object.options[`search`] = this.tableProps.search;
			//console.log(object.options);
			this.options = object.options;
            PageStateManager.setState(this.$router.history.current.path, 'optionsIndexTable', JSON.stringify(this.options));
			this.index();
		},
        trySearch(val){
            this.tableProps.search = val;
            this.options.search = val;
            this.options.page = 1;
            PageStateManager.setState(this.$router.history.current.path, 'optionsIndexTable', JSON.stringify(this.options));
            this.index();
        },
		index() {
            this.tableProps.items = [];
			this.tableProps.loading = true;
			let filter = Utils.createFilter(this.options, this.tableProps.headers);
			//call api
			this.$api.contractorPayment.list(this.$store.state.business, this.construction, filter)
				.then((resp) =>{
					//console.log(resp);
					this.tableProps.items = resp.data.data.map((x) => {
						x['actions'] = JSON.parse(JSON.stringify(this.actions))
                       
						
						x.actions[0].action = { name: 'ContractorsPaymentsEdit', params: { slug: x.slug } }
                        // x.actions[1].action = { name: 'ContractorsPaymentsEdit', params: { slug: x.slug } }
						

						x['parameters'] = { id: x.slug, name: x.slug}
                       
                        x.date = Utils.globalDateFormat(x.date);
                       
                        x.total = Utils.currencyFormat(x.total, x.currency);
						return x
					});
                    this.total = resp.data.total
				})
				.catch((error) =>{
					console.log(error);
				})
				.finally(() => {
					this.tableProps.loading = false;
				})
			;
		
		},

        openExportModal()
        {
            this.getProviders();
            this.modalExportProps = {
                ...this.modalExportProps,
                visible: true,
            }
        },

        export(){
            if(this.providerId == undefined || this.providerId == "")
                return;
            this.acceptExportModal.loading = true;
            this.$api.contractorPayment.downloadReport(this.$store.state.business, this.construction, this.providerId, this.format)
                .then((resp) => {
                    const fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute(
                    "download",
                    `${this.providerId.replaceAll("-","_")}.${this.format}`
                    );
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.acceptExportModal.loading = false;
                })
            ;
        },

        getProviders()
        {
            if(this.providers.length > 0)
                return;
            this.loadingProvider = true;
            this.$api.contractorPayment.getSelectSuppliers(this.$store.state.business, this.construction)
				.then((resp) =>{
					//console.log(resp, "desde form");
                    this.providers.push({value: "all", text: "Todos"});
					this.providers.push(...resp.data);
				})
				.catch((error) =>{
					console.log(error, "error");
				})
				.finally(() => {
                    this.loadingProvider = false;
				})
			;
        },

		deleteItemModal(parameters)
		{
			//console.log(parameters);
			this.selectedID = parameters.id;
			this.modalProps = {
				...this.modalProps,
				text: `¿Estás seguro de eliminar "${parameters.name}"?`,
				
			}
            console.log(this.selectedID)
			this.modalProps.visible = true;
			
		},


		delete()
		{
			//console.log(this.selectedID);
			this.acceptModal.loading = true;
			this.$api.contractorPayment.delete(this.$store.state.business, this.construction, this.selectedID)
			// eslint-disable-next-line
			.then((response) => {
				
				this.$store.dispatch('snackbarSuccess', `Se ha eliminado`);
				this.index()
				// eslint-disable-next-line
			}).catch(error => {
				if(error.response.status === 422){
                    this.$store.dispatch('snackbarError', `${error.response.data.error??'Error al eliminar'}`);
                }else{
                    this.$store.dispatch('snackbarError', `Error al eliminar. Intenta de nuevo`);
                }

				
			})
			.finally(() => {
				this.modalProps.visible = false;
				this.acceptModal.loading = false;
			})
		},

    }
}
</script>